import { AWS_BASE, CLOUDFLARE_DEFAULT_BASE } from '../../../constants'

export const IMG_URL_1 = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/city-page-part-time-driver-image-desktop@2x.jpg`

export const TITLE_OPPORTUNITY = `{jobTypeName} opportunity in {city}`
export const TITLE_REQUIREMENTS = `Requirements for {jobTypeName} in {city}`
export const TITLE_ABOUT = `About us`
export const TITLE_INFORMATION = `Additional information`

export const CONTENT_OPPORTUNITY_LINE_1 = `No passengers. No bosses. Just you, your tunes, and the road. Sign up now and start making money! Deliver food in {city} and other items from local merchants to hungry customers. It's a great alternative to seasonal work, temp work, or a part-time job.`
export const CONTENT_OPPORTUNITY_BULLET = [
  `Be your own boss. Work when you want, wherever you want`,
  `Qualify for Fast Pay and get paid daily`,
  `Use any car to deliver`,
]
export const CONTENT_OPPORTUNITY_LINE_2 = `Start today and be your own boss. Get on the road today.`

export const CONTENT_REQUIREMENTS = [
  `iPhone or Android smartphone`,
  `Valid driver's license and insurance`,
  `18+ years of age`,
  `1+ years of driving experience`,
]

export const CONTENT_WHAT_IS_DOORDASH_TITLE = 'What is DoorDash?'
export const CONTENT_WHAT_IS_DOORDASH_BODY =
  'DoorDash is a technology company that connects customers with local businesses. Customers order meals and other items from their favorite local merchants and Dashers deliver it directly to their doors.'

export const CONTENT_APPLY_TITLE = 'How to apply'
export const CONTENT_APPLY_BODY =
  'You can apply for this {jobTypeName} opportunity directly on the website. The sign up process requires that you enter info such as your  name, date of birth and drivers license number. You will also need to verify your identity (requires a SSN) and fill out a W9 form. The background check is usually fast.'

export const CONTENT_HOW_LONG_TITLE = 'How long does it take to apply?'
export const CONTENT_HOW_LONG_BODY =
  'To apply to be a {jobTypeName} driver in {city} it takes less than 30 minutes. Apply directly to accelerate the process!'

export const CONTENT_APPLICATION_TITLE =
  'How do I know my application is successful?'
export const CONTENT_APPLICATION_BODY =
  'One you become accepted as a driver in {city}, you will then receive an activation kit in the mail about a week later.'

export const CONTENT_PAY_TITLE =
  'How much do {jobTypeName}s in {city} get paid?'
export const CONTENT_PAY_BODY = [
  'We know that {jobTypeName} drivers in {city} have a lot of choices, which is why we’ve created a pay model that is designed to make earnings fair and transparent for every delivery. Below is more detailed information about how earnings work.',
  'Base Pay + Promotions + Tips = Total Earnings.',
  'Base pay is DoorDash’s base contribution for each order. This will range from $2-10+ depending on the estimated time, distance, and desirability of the order.',
  'Promotions are additional pay for orders that meet certain conditions, giving Dashers an opportunity to earn even more.',
]
export const CONTENT_PAY_DASHER_LINK = 'How is Dasher pay calculated?'
export const CONTENT_PAY_DASHER_LINK_HREF =
  'https://help.doordash.com/dashers/s/article/How-is-Dasher-pay-calculated?language=en_US'

export const CONTENT_WHAT_NEXT_TITLE = 'What is next?'
export const CONTENT_WHAT_NEXT_BODY = [
  'Sign up today, download the app and receive everything you need to start earning. A clear and concise pay model lets you know exactly how much you will make before accepting any order.',
  'Once you log in, you will see where the requests are coming from in real time. We also show you where the most orders are coming from, you can be in the right place at the right time. With DoorDash, when and where you work is totally up to you. Heatmaps will tell you where it’s busy or you can schedule deliveries based on your availability.',
  'Sign Up & Start Earning Right Away.',
]
